// Generated by Melange

import * as Buhta_cabinet__Btn from "../../html/Btn.js";
import * as Buhta_cabinet__Control from "../../../grpc/Control.js";
import * as Buhta_cabinet__Field from "../../html/Field.js";
import * as Buhta_components__Text from "../../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__GrpcState from "../../../../../../packages/core/lib/GrpcState.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function OrgSettingsBrand(Props) {
  let org = Props.org;
  const match = React.useState(function () {
    return "";
  });
  const setName = match[1];
  const arg = org.id;
  const func = Buhta_cabinet__Control.OrgService.view;
  const match$1 = Buhta_core__GrpcState.useModel((function (param) {
    return Curry._3(func, param, /* [] */ 0, arg);
  }), undefined);
  const dispatchOrg = match$1[1];
  const settingsOrg = match$1[0];
  React.useEffect((function () {
    Curry._2(dispatchOrg, undefined, undefined);
  }), []);
  React.useEffect((function () {
    if (typeof settingsOrg !== "string" && settingsOrg.NAME === "Data") {
      const org = settingsOrg.VAL;
      Curry._1(setName, (function (param) {
        return org.name;
      }));
    }
    
  }), [settingsOrg]);
  const saveSettings = function (ev) {
    ev.preventDefault();
  };
  let tmp;
  if (typeof settingsOrg === "string" || settingsOrg.NAME !== "Data") {
    tmp = null;
  } else {
    const settingsOrg$1 = settingsOrg.VAL;
    tmp = JsxRuntime.jsxs(React.Fragment, {
      children: [
        JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(Buhta_components__Text.H2.make, {
                  className: "max-w-[386px]",
                  children: settingsOrg$1.name
                }),
                JsxRuntime.jsx("div", {
                  children: settingsOrg$1.name.substring(0, 1),
                  className: "w-20 h-20 rounded-full bg-asphalt flex justify-center items-center text-white text-3xl font-semibold"
                })
              ],
              className: "flex justify-between"
            }),
            JsxRuntime.jsx(Buhta_cabinet__Field.make, {
              label: "Короткое название",
              type_: "text",
              name: "name",
              size: "m",
              required: true,
              onChange: (function (value) {
                Curry._1(setName, (function (param) {
                  return value;
                }));
              }),
              className: "mt-6",
              value: match[0]
            }),
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("img", {
                      className: "w-5 h-5",
                      alt: "info",
                      src: StaticAsset.src("/static/icons/info-dark-gray-20.svg")
                    }),
                    JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                      className: "text-asphalt",
                      children: "Короткое название будет отображаться только внутри интерфейсов Бухты"
                    })
                  ],
                  className: "p-4 flex gap-2"
                }),
                JsxRuntime.jsx("img", {
                  className: "w-[104px] h-[64px] mt-2",
                  alt: "phone",
                  src: StaticAsset.src("/static/images/half-phone.png")
                })
              ],
              className: "bg-gray-pale rounded-lg mt-2 flex justify-between pr-6"
            })
          ],
          className: "bg-white w-[562px] rounded-md shadow-kkm p-10"
        }),
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(Buhta_cabinet__Btn.make, {
            title: "Сохранить",
            className: "px-6 py-3",
            type_: "submit"
          }),
          className: "w-[562px] flex justify-end mt-6"
        })
      ]
    });
  }
  return JsxRuntime.jsx("form", {
    children: tmp,
    className: "flex flex-col items-center py-6",
    onSubmit: saveSettings
  });
}

const make = OrgSettingsBrand;

export {
  make,
}
/* Buhta_cabinet__Btn Not a pure module */
